// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import AutoPubCondensedReviewShape from './prop_shapes/autoPubCondensedReview'
import Const from '../Consts'
import { OverallRating } from 'components/review_ratings'
import pluralize from 'pluralize'

function AuthorInfo (props) {
  const { count } = props

  return (
    <div className='grid-x'>
      <div className='auto cell'>
        <div className='author-details'>
          <div className='font-bold pro-text-xs'>{pluralize('Additional Qualified Reviewer', count)}</div>
        </div>
      </div>
    </div>
  )
}

function AutoPubCondensedReview (props) {
  const { count, starRating, rating } = props
  return (
    <>
      <div className='pro-rounded pro-closest-shadow review-tile margin-bottom-2'>
        <div className='grid-x'>
          <div className='large-auto medium-12 cell author-info'>
            <AuthorInfo count={count} />
          </div>
          <div className='large-shrink medium-12 cell'>
            <div className='grid-x grid-margin-x'>
              <div className='large-shrink medium-4 small-12 cell'>
                <OverallRating ratingLabel={Const.RATING_TYPES.overall_rating} value={starRating} />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className='pro-text-s color-pro-steel-grey-700 review-body'>
          + {count} {pluralize('rating', count)} from additional Qualified Reviewers averaging {rating} stars.
        </div>
      </div>
    </>
  )
}

AutoPubCondensedReview.propTypes = {
  autoPubCondensedReview: AutoPubCondensedReviewShape
}

export default AutoPubCondensedReview
